import {
  faArrowTrendDown,
  faArrowTrendUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";

export default function DashboardCard({
  title,
  value,
  percent,
}: {
  title: ReactNode;
  value: ReactNode;
  percent?: ReactNode;
}) {
  const renderPercent = (percentValue: string | number) => {
    if (percentValue === "" || percentValue == null) return null;
    const valueNum = parseFloat(percentValue.toString());
    const isPositive = valueNum >= 0;
    return (
      <span
        style={{
          color: isPositive ? "#1B8D2F" : "#B20023",
          display: "flex",
          alignItems: "center",
          gap: 4,
          fontWeight: "bold",
        }}
      >
        <FontAwesomeIcon
          icon={isPositive ? faArrowTrendUp : faArrowTrendDown}
          className="dashboard-card-icon"
        />
        {percentValue}
      </span>
    );
  };

  return (
    <span className="home-dash-card">
      <span className="dash-card-row dash-card-header">
        <span className="title">{title}</span>
      </span>
      <span className="dash-card-row" style={{ backgroundColor: "#f5f5f5" }}>
        <span className="number">
          {typeof value === "number"
            ? value.toLocaleString("en-US", { maximumFractionDigits: 0 })
            : value}
        </span>
        {(typeof percent === "string" || typeof percent === "number") && (
          <div className="dashboard-card-percent">{renderPercent(percent)}</div>
        )}
      </span>
    </span>
  );
}
